export default "/img/IS.ba843ccacc9059ae8ef00ec71977ccef.png";